const running=new Set();
const enabled=()=>!matchMedia('(prefers-reduced-motion: reduce)').matches&&!document.documentElement.classList.contains('motion-paused');
const reveal=(element,direction=1)=>{
 if(!element||!enabled())return;
 const animation=element.animate([{opacity:.15,transform:`translate3d(${direction*18}px,16px,0) scale(.98)`},{opacity:1,transform:'translate3d(0,0,0) scale(1)'}],{duration:560,easing:'cubic-bezier(.16,1,.3,1)'});
 running.add(animation);animation.finished.catch(()=>{}).finally(()=>running.delete(animation));
};
addEventListener('onestep:motion',()=>{if(!enabled())running.forEach(animation=>animation.cancel());});
module.exports={reveal,enabled};
